// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TosPopup_tos_title__G7t8w {
  padding-bottom: 35px;
  font-weight: 300;
  font-size: 15px;
}

.TosPopup_tosContentContainer__qZi23 {
  width: 850px;
  height: 500px;
  padding: 10px;
  background-color: var(--color-theme-white);
  color: var(--color-font-0);
  overflow-y: scroll;
}

.TosPopup_iframe__NuG\\+g {
  width: 100%;
  height: 100%;
  color: var(--color-font-0);
  overflow-y: scroll;
  border: none;
}
`, "",{"version":3,"sources":["webpack://./src/@_components/popups/TosPopup/TosPopup.module.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,0CAA0C;EAC1C,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,YAAY;AACd","sourcesContent":[".tos_title {\n  padding-bottom: 35px;\n  font-weight: 300;\n  font-size: 15px;\n}\n\n.tosContentContainer {\n  width: 850px;\n  height: 500px;\n  padding: 10px;\n  background-color: var(--color-theme-white);\n  color: var(--color-font-0);\n  overflow-y: scroll;\n}\n\n.iframe {\n  width: 100%;\n  height: 100%;\n  color: var(--color-font-0);\n  overflow-y: scroll;\n  border: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tos_title": `TosPopup_tos_title__G7t8w`,
	"tosContentContainer": `TosPopup_tosContentContainer__qZi23`,
	"iframe": `TosPopup_iframe__NuG+g`
};
export default ___CSS_LOADER_EXPORT___;
